
var upManager = {
  enabled: true,
  template: null,
  token: null,
  cartItems: null,
  lineItemTotal: 0,
  index: 0,
  queue: [],
  manual: function() {
    this.enabled = true;
    this.replaceCheckout();
  },
  addToQueue: function(obj, weight) {
    console.log("addToQueue Called");
    if (!upManager.newToken())
    {
      console.log("Exiting from new Token check");
      return;
    }
    if (obj.hasOwnProperty("checkItems"))
    {
      if (!obj.checkItems(this.cartItems))
      {
        console.log("Exiting from item check");
        return;
      }
    }
    this.queue.push({
      obj: obj,
      weight: weight
    });
    this.sortQueue();
  },
  sortQueue: function() {
    this.queue.sort((a, b) => (a.weight < b.weight) ? 1 : -1);
  },
  /*removeFromQueue: function(obj) {
    //let i = this.queue.findIndex(obj);
    console.log("Trying to remove from queue")
    let i = this.queue.findIndex(x => x === obj);
    this.queue.splice(i, 1);
  },*/
  replaceCheckout: function(){
    if (!upManager.enabled)
      return;
    if (upManager.template != "cart")
      return;
    
    let elm = document.getElementById("checkout-wrapper");
    elm.innerHTML = "";
    let btn = document.createElement("button");
    btn.setAttribute("type", "button");
    btn.innerHTML = "CHECK OUT";
    btn.setAttribute("class", "btn cart__checkout");
    //btn.setAttribute("onclick", "p31cart.showPopup()");
    btn.setAttribute("onclick", "upManager.gotoNext()");
    elm.appendChild(btn);
  },
  getCart: function(){
    let args = {
      endpoint: "/cart.js",
      method: "GET",
      callback: function(obj){
        upManager.token = obj.token;
        upManager.cartItems = obj.items;
        upManager.lineItemTotal = obj.items_subtotal_price;
      }
    };
    p31help.doCall(args);
  },
  newToken: function(){
    if (this.token != p31help.cookie.get("cartToken"))
      return true;
    return false;
  },
  gotoNext: function() {
    if (this.index >= this.queue.length)
      this.gotoCheckout();
    else
    {
      if (this.index == 0)
        this.showPopup();
      this.queue[this.index].obj.display();
      this.index += 1;
    }
  },
  gotoCheckout: function() {
    p31help.cookie.set("cartToken", this.token, 1);
    this.showLoading();
    let form = null;
    if (this.template == "cart")
    	form = document.getElementById("CartPageForm");
    else if (this.template == "product")
      	form = document.getElementById("AddToCartForm-" + p31cart.sectionId);
    if (form == null)
      window.location.href = "/checkout";
    else
    {
      form.action = "/checkout";
      form.submit();
    }
  },
  showPopup: function(){
    this.checkBanner();
    document.getElementById("upsell-wrapper").style = "display:block;";
    document.body.style = "overflow: hidden;";
  },
  showLoading: function(){
    document.getElementById("modal-loading").style = "display: flex;";
    document.getElementById("modal-content").style = "overflow: hidden;";
  },
  checkBanner: function() {
    let vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    if (vw <= 768)
    {
      let banner = document.getElementsByClassName("cc-window")[0];
      if (banner != null)
      {
        if (banner.style.display != "none")
        {
          document.getElementById("modal-content").style.paddingBottom = "150px";
          document.getElementsByClassName("modal-footer")[0].style.paddingBottom = "150px";
        }
      }
    }
  },
  addItem: function(itemId){
  	let formData = {
     'items': [{
      'id': itemId,
      'quantity': 1
      }]
    };
    
    let args = {
      endpoint: "/cart/add.js",
      method: "POST",
      data: formData,
      callback: function(obj){
        upManager.gotoNext();
      }
    };
  	p31help.doCall(args);
    if (this.index >= this.queue.length)
      this.showLoading();
  },
  addProduct: function(){
    //old selector $('#AddToCartForm-' + this.sectionId)
    let formData = $('form[action="/cart/add"]').serializeArray().reduce(function(obj, item) {
        obj[item.name] = item.value;
        return obj;
    }, {});
        
    let args = {
      endpoint: "/cart/add.js",
      method: "POST",
      data: formData
    };

	if (this.newToken())
    	this.gotoNext();
	else
      args.callback = function(obj){upManager.gotoCheckout()};
	p31help.doCall(args);
  }
}

upManager.getCart();
var upsell_manager_checkExist = setInterval(function() {
   if ($('#checkout-wrapper').length) {
      upManager.replaceCheckout();
      clearInterval(upsell_manager_checkExist);
   }
}, 5); // check every 5ms